import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    loading: _ctx.isLoading,
    color: _ctx.color,
    onClick: _ctx.select
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.label) + " (" + _toDisplayString(_ctx.total) + ") ", 1)
    ]),
    _: 1
  }, 8, ["loading", "color", "onClick"]))
}